export default __webpack_public_path__ + "static/media/four-dots.909e9d3c.svg";